
import { ProfessionData } from '../types/professionTypes';

export const carreleur: ProfessionData = {
  title: "Carreleur",
  slug: "carreleur",
  description: "Solutions de recyclage pour les déchets de carrelage",
  icon: "Square",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Chutes de carrelage",
      description: "Morceaux de carreaux et découpes de céramique, faïence ou grès.",
      solutions: ["Benne pour gravats propres", "Concassage et réutilisation"],
      environmentalBenefit: "Valorisation en granulats pour remblais"
    },
    {
      type: "Résidus de colles et joints",
      description: "Restes de mortier-colle, joints et produits de préparation.",
      solutions: ["Collecte en seaux", "Traitement spécifique"],
      environmentalBenefit: "Évite la contamination des autres déchets"
    },
    {
      type: "Emballages",
      description: "Sacs de ciment, poudres et emballages plastiques.",
      solutions: ["Tri sélectif", "Compactage"],
      environmentalBenefit: "Valorisation des emballages par matériau"
    }
  ],
  relatedProfessions: ["macon", "platrier", "peintre"]
};
